var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = $('body').data('money-format');
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function updateSubscription(){
  $('.mrk-hidden-inputs').html('');
  var qty = Number($('.kaching-bundles__bar input[name="kaching-bundles-deal"]:checked').val().replace('units','').replace('unit',''));
  var rem_value = qty - 1;
  var seling_plan_id = $('input[name="selling_plan_id"]').val();
  var mrk_id = $('.product-variant-id').val();
  
  if(qty == 3){
    var mrk_id = window.mrkThreeBundleVariantId;
    var selling_plan = window.mrkThreeBundleVariantSubscription
  }
  if(qty == 5){
    var mrk_id = window.mrkFiveBundleVariantId;
    var selling_plan = window.mrkFiveBundleVariantSubscription
  }
  console.log(qty, mrk_id, selling_plan);
  if(qty == 1){
    $('input[name="quantity"]').val(qty);
    $('#selling_plan').attr('name','selling_plan').val(seling_plan_id);
  }else{
    $('#selling_plan').attr('name','').val('');
    $('input[name="quantity"]').val(rem_value);
    $('.mrk-hidden-inputs').html(`<input name="items[1][selling_plan]" type="hidden" value="${selling_plan}" /><input name="items[1][quantity]" type="hidden" value="1" /><input name="items[1][id]" type="hidden" value="${mrk_id}" /><input name="properties[Note]" type="hidden" value="In total ${qty} will be shipped including 1 subscription item." />`);    
  }
}
$("input#upgrade-subscription").change(function() {
    updateSubscription()
    if ($(this).is(':checked')) {
      console.log('Is Subscription!');
      var seling_plan_id = $('input[name="selling_plan_id"]').val();
      $('.kaching-bundles__bar').each(function(i, obj) {
        var kaching_bundle_id = $(this).data('deal-bar-id');
        var sub_price = $(this).find('.kaching-bundles__bar-price').data('sub-price');
        $(this).find('.kaching-bundles__bar-price').text(Shopify.formatMoney(sub_price, $('body').data('money-format')));
        var sub_price_saving = $(this).find('.kaching-bundles__bar-label').data('save-sub-price');
        if(sub_price_saving > 0){
          $(this).find('.kaching-bundles__bar-full-price').show();
          $(this).find('.kaching-bundles__bar-label').show().text('SAVE '+Shopify.formatMoney(sub_price_saving, $('body').data('money-format')));
        }else{
          $(this).find('.kaching-bundles__bar-full-price').hide();
          $(this).find('.kaching-bundles__bar-label').hide().text('SAVE '+Shopify.formatMoney(sub_price_saving, $('body').data('money-format')));
        }
      });
    } else {
      console.log('Is Onetime!');
      $('#selling_plan').attr('name','').val('');
      $('.kaching-bundles__bar').each(function(i, obj) {
        var kaching_bundle_id = $(this).data('deal-bar-id');
        var onetime_price = $(this).find('.kaching-bundles__bar-price').data('ot-price');
        $(this).find('.kaching-bundles__bar-price').text(Shopify.formatMoney(onetime_price, $('body').data('money-format')));
        var onetime_price_saving = $(this).find('.kaching-bundles__bar-label').data('save-ot-price');
        if(onetime_price_saving > 0){
          $(this).find('.kaching-bundles__bar-full-price').show();
          $(this).find('.kaching-bundles__bar-label').show().text('SAVE '+Shopify.formatMoney(onetime_price_saving, $('body').data('money-format')));
        }else{
          $(this).find('.kaching-bundles__bar-full-price').hide();
          $(this).find('.kaching-bundles__bar-label').hide().text('SAVE '+Shopify.formatMoney(onetime_price_saving, $('body').data('money-format')));
        }
      });
      var qty = $('.kaching-bundles__bar input[name="kaching-bundles-deal"]:checked').val().replace('units','').replace('unit','');
      $('input[name="quantity"]').val(qty);
      $('.mrk-hidden-inputs').html('');
    }
    
  });

  $(document).ready(function(e) {
    console.log('window ready');
    var seling_plan_id = $('input[name="selling_plan_id"]').val();
    $('#selling_plan').attr('name','selling_plan').val(seling_plan_id);

    $('.kaching-bundles__bar input[name="kaching-bundles-deal"]').change(function() {
      $('.kaching-bundles__bar').removeClass('kaching-bundles__bar--selected');
      $(this).closest('.kaching-bundles__bar').addClass('kaching-bundles__bar--selected');
      // console.log($(this).val());
      
      updateSubscription();
    });
    $('.kaching-bundles__bar input[name="kaching-bundles-deal"]:checked').trigger('change');
    
  });
  